import { FlexContainer, reference } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { FRONT_PLANS } from 'Constants/plans';

const planColors = {
  [FRONT_PLANS.FULL]: reference.plans.full_200,
  [FRONT_PLANS.PRO]: reference.plans.pro_200,
};

export const Container = styled(FlexContainer)<{ plan: string }>`
  background-color: ${({ plan }) => planColors[plan]};
  padding: ${reference.dimension_16};
`;

export const ButtonContainer = styled(FlexContainer)`
  width: 358px;
  @media (max-width: ${reference.breakpoints.MOBILE_WIDTH}) {
    width: 100%;
  }
`;
